export const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_DEV_MODE
    : process.env.REACT_APP_PRO_MODE;

export const LOGIN_URL = BASE_URL + '/auth/login';

export const ME_URL = BASE_URL + '/me';
export const USER_URL = BASE_URL + '/user';
export const TRUCK_URL = BASE_URL + '/truck';
export const TRAILER_URL = BASE_URL + '/trailer';
export const CHANGE_TARGET_URL = BASE_URL + '/change-target';
